import { publicHttp } from "../httpHandler";
import { links } from "@/constants";
import { ErrorSubcode } from "@/types";

export interface CheckoutSuccessResponse {
  success: boolean;
  message: string;
  subcode?: ErrorSubcode;
  error?: string;
  email: string;
  domain: string;
}

export const CHECKOUT_SUCCESS = "CHECKOUT_SUCCESS";
export const CHECKOUT_RESEND_WELCOME = "CHECKOUT_RESEND_WELCOME";

export const validateCheckoutSession = async (
  sessionId: string,
): Promise<CheckoutSuccessResponse> => {
  const response = await publicHttp.get<CheckoutSuccessResponse>(
    `${links.checkout.success}`,
    {
      params: {
        session_id: sessionId,
      },
    },
  );
  return response.data;
};

export interface ResendWelcomeEmailResponse {
  success: boolean;
  message: string;
}

export const resendWelcomeEmail = async (
  sessionId: string,
): Promise<ResendWelcomeEmailResponse> => {
  const response = await publicHttp.post<ResendWelcomeEmailResponse>(
    `${links.checkout.resendWelcome}`,
    { sessionId },
  );
  return response.data;
};
